import { render } from "./MbNameDisp.vue?vue&type=template&id=059e08ca"
import script from "./MbNameDisp.vue?vue&type=script&lang=js"
export * from "./MbNameDisp.vue?vue&type=script&lang=js"

import "./MbNameDisp.vue?vue&type=style&index=0&id=059e08ca&lang=scss"
script.render = render

export default script